<app-material>
    <div class="header" header>
        <h2>{{ 'lineSetter.pending-tool-returns.table.title' | translate }}</h2>
        <app-icon library="material" variant="filter_list" (click)="toggleFilters()"></app-icon>
    </div>
    <ng-container body>
        <app-pending-tool-returns-table [pendingToolReturns]="pendingToolReturns"
                                        [(statusFilters)]="filterStatusList"
                                        [tableConfig]="tableConfig"
                                        [isLoading]="isLoading"
                                        [headerBackgroundColor]="'rgba(162, 186, 210, .3)'"
                                        [showFilters]="showFilters"
                                        [isMaterial]="false"
                                        [hasTitle]="false"
                                        (sortChange)="onSortChange($event)" (filterChange)="onFilter($event)"
                                        (rowClick)="onTableRowClick($event)"
                                        (pageChange)="onPageChange($event)">
        </app-pending-tool-returns-table>
    </ng-container>
</app-material>
<app-pending-tool-returns-modal label='lineSetter.pending-tool-returns.table.details-modal.title'
                                (closeToolReturn)="onClose($event)"
                                [isConfirmationInProgress]="isConfirmationInProgress">
</app-pending-tool-returns-modal>
<app-confirmation-modal #errorModal title="{{'lineSetter.toolRequest.pages.popupError' | translate }}"
                        [message]="confirmationPopupMessage" [confirmOnlyMode]="true" [showConfirmButton]="false ">
</app-confirmation-modal>
<app-logout-modal
    title="{{ 'lineSetter.pending-tool-returns.table.logoutModal.title' | translate }}"
    infoMessage="{{ 'lineSetter.pending-tool-returns.table.logoutModal.infoMessage' | translate }}"
    [timer]="badgeLogoutCountdownSeconds">
</app-logout-modal>
